export default "__VITE_PUBLIC_ASSET__4467c7dc__"